import { switchToKeyboard } from '@alfa-bank/site-helpers-common/browser/keyboard-switcher';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Dispatch, FocusEvent, SetStateAction } from 'react';

import * as config from './config';

export interface IEmailFieldHandler {
    callback: ((obj: IInputProps) => void) | undefined;
    setOptions: Dispatch<SetStateAction<IEmailSuggestionsData[]>>;
    setValue: Dispatch<SetStateAction<string>>;
}

export interface IInputProps {
    event: FocusEvent<HTMLElement>;
    name: string;
    value: string;
}

export interface IAxiosResponseData {
    value: string;
}

export interface IEmailSuggestionsData {
    id: string;
    label: string;
}

export const formatEmail: (value: string) => string = value =>
    switchToKeyboard(value, 'en')
        .toLowerCase()
        .replace(/^[.@_-]/, '')
        .replace(/[^\w-.@]/g, '');

export const getEmailSuggestions: (value: string) => Promise<IEmailSuggestionsData[]> =
    async value => {
        if (!value.includes('@')) return [];
        const { headers, method, ref, timeout, url } = config;
        const request: AxiosRequestConfig = {
            method,
            timeout,
            url,
            headers,
            data: `_ref=${ref}&value=${value}`,
        };

        const { data }: AxiosResponse<IAxiosResponseData[]> = await axios(request);

        return data.map(({ value: val }) => ({
            id: val,
            label: val,
        }));
    };
